module.exports = __webpack_public_path__ + "static/media/ethereum.2b470564.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/ethereum.svg
// module id = 1138
// module chunks = 0